import styled from '@emotion/styled';

export const Container = styled.div``;

export const Slides = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  overflow: hidden;
  top: 0;
  left: 0;
`;

export const SlidesWrapper = styled.div`
  height: 100vh;
  width: 100%;
  position: sticky;
  top: 0;
`;
